export function mapWalletHistory(item) {
  const rawWalletHistories = item?.walletHistories || [];

  //
  // 1. GROUPED BY ACTION (you asked to rename it)
  //
  const summarizedByAction = rawWalletHistories.reduce((acc, h) => {
    const key = h?.action || "UNKNOWN";
    if (!acc[key]) acc[key] = [];
    acc[key].push(h);
    return acc;
  }, {});

  //
  // 2. SUMMED VERSION (same entries as raw but actions merged)
  //
  const summedByActionMap = rawWalletHistories.reduce((acc, h) => {
    const key = h?.action || "UNKNOWN";

    if (!acc[key]) {
      acc[key] = {
        ...h,
        amount: h.amount ?? 0, // initialize
      };
    } else {
      const amount = h.amount ?? 0;
      acc[key].amount = (acc[key].amount ?? 0) + amount;
    }

    return acc;
  }, {});

  const walletHistories = Object.values(summedByActionMap);

  return {
    ...item,
    rawWalletHistories, // original detailed list
    summarizedByAction, // renamed grouped version
    walletHistories, // summed version
  };
}
